export interface RetryUntilSuccessOptions {
  // Espera antes de cada nova tentativa; depois do fim da lista repete o último valor.
  delaysMs?: number[];
  onError?: (error: any, attempt: number) => void;
  // Quando devolve true, para de tentar e a promessa resolve com undefined.
  isCancelled?: () => boolean;
  sleep?: (ms: number) => Promise<void>;
}

const DEFAULT_DELAYS_MS = [2000, 5000, 10000, 30000];

const defaultSleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export const retryUntilSuccess = async <T>(
  operation: () => Promise<T>,
  options: RetryUntilSuccessOptions = {}
): Promise<T | undefined> => {
  const { delaysMs = DEFAULT_DELAYS_MS, onError, isCancelled, sleep = defaultSleep } = options;

  for (let attempt = 1; ; attempt++) {
    try {
      return await operation();
    } catch (error) {
      onError?.(error, attempt);

      if (isCancelled?.()) {
        return undefined;
      }

      await sleep(delaysMs[Math.min(attempt - 1, delaysMs.length - 1)]);

      if (isCancelled?.()) {
        return undefined;
      }
    }
  }
};
